import React, { Fragment } from "react"
import Calendar from "Components/Calendar"
import Typography from "@material-ui/core/Typography"

export default function Wechat() {
    return (
        <Fragment>
            <Calendar channelName={"微信"} />
            <Typography component="div">
                <pre style={{whiteSpace: 'pre-line'}}>
                    预约规则：<br />
                    1.所有需求不上下两两相连。举例：头条、二条不相连，二条、三条不相连。<br />

                    2.每日头条需求最多2个，每日尾条（第5条）以外需求总量最多3个。<br />

                    3.周一至周五头条需求最多7个，周末不限。<br />

                    ----------------------------------------<br />

                    4.2B（含政府项目），头条每天最多1个。<br />

                    ----------------------------------------<br />

                    5.2C部门头条，周一到周五每天最多1个，每周上限3个；周六日每天最多2个，每周上限4个。<br />

                    6.2C只能约2周之内的点位。<br />

                    ----------------------------------------<br />

                    如2B、2C冲突，坑位排期请联系吴瑕（微信：wuxiabeijing）沟通，其他请联系小树（微信号：sunnymeak）沟通。<br />
                </pre>
            </Typography>
            <div id="board_input_modal" />
        </Fragment>
    )
}
